import React from 'react';
import PropTypes from 'prop-types';
import { StyledError } from './styled';

const FormError = ({ children, customStyle }) => {
    return (
        <StyledError
            customStyle={customStyle}
        >
            {children}
        </StyledError>
    );
};

FormError.propTypes = {
    children: PropTypes.node,
    customStyle: PropTypes.array
};

FormError.defaultProps = {};

export default React.memo(FormError);
